var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addEditForm" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, "label-width": "170px", rules: _vm.rules },
        },
        [
          _c(
            "el-row",
            { staticClass: "marRight20" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "课程名称", prop: "name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "主持老师", prop: "presidedTeacher" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.presidedTeacher,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "presidedTeacher", $$v)
                      },
                      expression: "form.presidedTeacher",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "专业大类", prop: "majorId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择专业大类" },
                      model: {
                        value: _vm.form.majorId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "majorId", $$v)
                        },
                        expression: "form.majorId",
                      },
                    },
                    _vm._l(_vm.prolist, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.majorName, value: i.majorName },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$store.state.user.userInfo.roleType == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "学校", prop: "emceeCompanyname" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "学校" },
                          model: {
                            value: _vm.form.emceeCompanyname,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "emceeCompanyname", $$v)
                            },
                            expression: "form.emceeCompanyname",
                          },
                        },
                        _vm._l(_vm.schoolListData, function (i) {
                          return _c("el-option", {
                            key: i.id,
                            attrs: { label: i.name, value: i.name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "学习人数", prop: "userCount" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.userCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "userCount", $$v)
                      },
                      expression: "form.userCount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "课程封面：" } },
                [
                  _c("file-upload", {
                    staticClass: "img",
                    attrs: { accept: _vm.accept, propImg: _vm.form.previewPic },
                    on: { successUpLoad: _vm.successUpLoad },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "免登录链接", prop: "freeLoginLink" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.freeLoginLink,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "freeLoginLink", $$v)
                      },
                      expression: "form.freeLoginLink",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "课程链接", prop: "link" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.link,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "link", $$v)
                      },
                      expression: "form.link",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "10",
                      "show-word-limit": "",
                      placeholder: "请输入排序",
                    },
                    on: {
                      input: function (e) {
                        return (_vm.form.sort = _vm.isnumber(e))
                      },
                    },
                    model: {
                      value: _vm.form.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sort", $$v)
                      },
                      expression: "form.sort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "课程来源", prop: "origin" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.origin,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "origin", $$v)
                      },
                      expression: "form.origin",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "项目级别" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.form.majorLevel,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "majorLevel", $$v)
                        },
                        expression: "form.majorLevel",
                      },
                    },
                    _vm._l(_vm.List, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.name, value: i.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "产业分类" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.form.industry,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "industry", $$v)
                        },
                        expression: "form.industry",
                      },
                    },
                    _vm._l(_vm.industryList, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.name, value: i.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "行业门类" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.form.industryDetail,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "industryDetail", $$v)
                        },
                        expression: "form.industryDetail",
                      },
                    },
                    _vm._l(_vm.industryCategoryList, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.name, value: i.remark },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "submitBtn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.submit("form")
                },
              },
            },
            [_vm._v("确定")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.isBack } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }